import {
	ChangeDetectionStrategy,
	Component,
	Input,
	Output,
	EventEmitter,
} from '@angular/core';

import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatRippleModule } from '@angular/material/core';
import { AuDocumentTypeComponent } from '@shared/ui-components/au-document-type/au-document-type.component';
import { FileDocumentType } from '@app/pages/cmms/interfaces/files.interfaces';
import { NgxTolgeeModule } from '@tolgee/ngx';

export const documentTypes = [
	'REPORT',
	'SERVICE_AGREEMENT',
	'USER_MANUAL',
	'REGULATION',
	'DRAWING',
	'IMAGE',
] as const;

@Component({
	selector: 'document-type',
	imports: [
		MatMenuModule,
		MatIconModule,
		MatRippleModule,
		AuDocumentTypeComponent,
		NgxTolgeeModule,
	],
	templateUrl: './document-type.component.html',
	styleUrls: ['./document-type.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentTypeComponent {
	@Output() typeChanged = new EventEmitter<FileDocumentType>();
	@Input() documentType: FileDocumentType;

	readonly documentTypes = documentTypes;
}
